<template>
  <app-loading :loading="loading" class="fertilizer-summary">
    <div class="title">
      {{$ml.get('Fertilizer summary')}}
    </div>
    <table>
      <tr class="head">
        <td>{{$ml.get('Fertilizer')}}</td>
        <td>{{$ml.get('Application amount')}}</td>
      </tr>
      <tr v-for="item in data" v-if="item.Concentration">
        <td>{{ item.Name }}</td>
        <td>{{ $store.getters['unit/convert']('kg', item.Concentration)}} {{$store.getters['unit/getLabel']('kg')}} </td>
      </tr>
    </table>
  </app-loading>
</template>

<script>
import { ProgramAPI } from '@/api';
export default {
  data() {
    return {
      data: [],
      loading: false,
    }
  },
  methods: {

    sync() {
      this.loading = true;
      return ProgramAPI.getFertilizerSummary(this.$store.getters['program/data'].id)
        .then(res => {
          this.data = res.data;
        })
        .finally(() => {
          this.loading = false;
        });
    },
  },

  created() {
    this.sync();
  },
}
</script>

<style lang="scss" scoped>

.fertilizer-summary {
  width: 100%;
  padding-bottom: 30px;
  min-height: 100px;

  .title {
    font-weight: bold;
    font-size: 20px;
    padding: 20px 0;
  }

  table {
    width: 100%;
    border-spacing: 0;
    border: 1px solid rgba($color: #333, $alpha: 0.1);
    border-radius: 3px;
    td {
      font-weight: bold;
      font-size: 14px;
      padding: 10px 15px;
      border-bottom: 1px solid rgba($color: #333, $alpha: 0.1);
    }
    tr {
      &:last-child {
        td {
          border-bottom: 0;
        }
      }
    }
    .head {
      td {
        font-weight: normal;
        font-size: 12px;
      }
    }
  }
}

</style>
